import { render, staticRenderFns } from "./FormQuestion.vue?vue&type=template&id=3a8a09ae&scoped=true"
import script from "./FormQuestion.vue?vue&type=script&lang=js"
export * from "./FormQuestion.vue?vue&type=script&lang=js"
import style0 from "./FormQuestion.vue?vue&type=style&index=0&id=3a8a09ae&prod&scoped=true&lang=css"
import style1 from "./FormQuestion.vue?vue&type=style&index=1&id=3a8a09ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8a09ae",
  null
  
)

export default component.exports